function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, notification, Select } from 'antd';
import { Spinner } from "react-bootstrap";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var UserRegister = function UserRegister(_ref) {
  var handleRegister = _ref.handleRegister;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    registrationStatus = _useState2[0],
    setRegistrationStatus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    formLoading = _useState4[0],
    setFormLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFormError = _useState6[0],
    setIsFormError = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    countryList = _useState10[0],
    setCountryList = _useState10[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    setFormLoading(true);
    setIsFormError(false);
    var formData = new FormData();
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);
    formData.append('mobile', values.mobile);
    formData.append('country_id', values.country_id);
    formData.append('password', values.password);
    axios.post(Common.baseApiUrl + 'createuser', formData).then(function (response) {
      setFormLoading(false);
      if (response.data.status == 200 || response.data.status == 201 || response.data.status == 202) {
        setRegistrationStatus(true);
        console.log('Reg Ok');
        console.log(response.data.status.toString());
        handleRegister(values.mobile, values.firstname);
        localStorage.removeItem('userData');
        localStorage.setItem('userData', JSON.stringify(response.data.user));
        localStorage.setItem('isOn', true);
      }
      if (response.data.status == 500 || response.data.status == 501) {
        setErrorMessage(response.data.message);
        setIsFormError(true);
      }
    })["catch"](function (error) {
      console.log('Une erreur est survenue');
    })["finally"](function () {
      setFormLoading(false);
    });
  };
  var onFinishFailed = function onFinishFailed(errorInfo) {
    console.log('Failed:', errorInfo);
  };
  useEffect(function () {
    form.setFieldsValue({
      firstname: '',
      lastname: '',
      mobile: ''
    });
    axios.get("".concat(Common.baseApiUrl, "getcountries")).then(function (response) {
      if (response.data.status == 200) {
        setCountryList([]);
        response.data.countries.forEach(function (c) {
          setCountryList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
        if (response.data.countries.length > 0) form.setFieldsValue({
          country_id: response.data.countries[0].id
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: 'Erreur',
        description: "Impossible de charger les données"
      });
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        fontSize: '17px',
        padding: '5px 0px 10px 0px'
      },
      children: ["Bienvenu sur ", /*#__PURE__*/_jsx("b", {
        children: "Naatou"
      }), ", cr\xE9er votre compte en une minute"]
    }), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      initialValues: {
        remember: true
      },
      onFinish: onFinish,
      onFinishFailed: onFinishFailed,
      form: form,
      autoComplete: "off",
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "country_id",
        label: "Pays",
        rules: [{
          required: true,
          message: 'Veuillez choisir unn pays'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          options: countryList
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Votre pr\xE9nom",
        name: "firstname",
        rules: [{
          required: true,
          message: 'Veuillez entrer votre prénom'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Votre nom",
        name: "lastname",
        rules: [{
          required: true,
          message: 'Veuillez entrer votre nom'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Num\xE9ro mobile",
        name: "mobile",
        rules: [{
          required: true,
          message: 'Veuillez entrer un numéro de téléphone'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Mot de passe",
        name: "password",
        rules: [{
          required: true,
          message: 'Le mot de passe est obligatoire !'
        }],
        children: /*#__PURE__*/_jsx(Input.Password, {})
      }), isFormError ? /*#__PURE__*/_jsx(Alert, {
        style: {
          marging: '5px 0px',
          fontSize: '14px'
        },
        message: errorMessage,
        type: "error",
        showIcon: true
      }) : /*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: formLoading,
          disabled: countryList.length == 0,
          type: "primary",
          size: "middle",
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: "COMMENCER"
          })
        })
      })]
    })]
  });
};
export default UserRegister;